module.exports = __webpack_public_path__ + "static/portfolio1-3ce57e931cadb40dec4bafe91aa8b2ed.jpg";